// extracted by mini-css-extract-plugin
module.exports = {"mssUpdate":"detail-proa_mssUpdate__3tJWB","yearsRange":"detail-proa_yearsRange__2O4kd"};